import { useTranslation } from "react-i18next";
import { useConnectionLost } from "../app/connectivity";

export function NetworkBanner() {
  const { t } = useTranslation();
  const lost = useConnectionLost();
  return (
    <div role="status" aria-live="polite">
      {lost && <p className="bg-amber-100 px-4 py-2 text-sm text-amber-950">{t("network.offline")}</p>}
    </div>
  );
}
